import { SectionCardInterface } from "./interfaces/SectionCardInterface";

export const PRIVATE_SECURITY_CARDS: Array<SectionCardInterface> = [
    {
        title: 'titulo1',
        content: 'contenido',
        imgLink: 'assets/section-card-1.jpg',
        link: '#',
    },
    {
        title: 'titulo2',
        content: 'contenido',
        imgLink: 'assets/section-card-1.jpg',
        link: '#',
    },
    {
        content: 'contenido',
        title: 'titulo3',
        imgLink: 'assets/section-card-1.jpg',
        link: '#',
    },
]

